import { Component, Input, NgModule, OnInit } from '@angular/core';
import { AuthorComponentModule } from '@component/author/author.component';
import { CommentButtonComponent } from '@component/interaction-buttons/comment-button/comment-button.component';
import { ShareButtonComponentModule } from '@component/interaction-buttons/share-button/share-button.component';
import { ViewsDisplayModule } from '@component/interaction-buttons/views-display/views-display.component';
import { ShareDialogComponentModule } from '@modal/share-dialog/share-dialog.component';
import { Blog } from '@model/entities/blog';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { ScrollService } from '@service/scroll.service';
import { StateService } from '@service/state.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { SharedModule } from 'src/app/shared.module';
import { EntityCardComponent } from '../entity-card.component';

@Component({
  selector: 'blog-card',
  templateUrl: './blog-card.component.html',
  styleUrls: ['./blog-card.component.scss'],
})
export class BlogCardComponent extends EntityCardComponent implements OnInit {
  protected entityTypeIdentifier: EntityTypeIdentifier = 'blog';

  @Input()
  public entity: Blog = null;

  constructor(
    protected entityTypeConfigService: EntityTypeConfigService,
    protected ScrollService: ScrollService,
    public StateService: StateService,
  ) {
    super(entityTypeConfigService, ScrollService, StateService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}

@NgModule({
  declarations: [BlogCardComponent, CommentButtonComponent],
  imports: [
    SharedModule,
    ShareDialogComponentModule,
    ShareButtonComponentModule,
    ViewsDisplayModule,
    AuthorComponentModule,

    // entities module <- dont import this because jobcard is used in profile
  ],
  exports: [
    BlogCardComponent,
    CommentButtonComponent,
    ViewsDisplayModule,
    AuthorComponentModule,

    SharedModule,
    ShareDialogComponentModule,
    ShareButtonComponentModule,
  ],
})
export class BlogCardComponentModule {}
